import { render, staticRenderFns } from "./MultiLanguage.vue?vue&type=template&id=1b56d85e"
import script from "./MultiLanguage.vue?vue&type=script&lang=js"
export * from "./MultiLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports